import React, {Component} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {ModalHeader, ModalBody, ModalFooter, Modal, Button} from "reactstrap";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import 'ladda/dist/ladda-themeless.min.css';
import PropTypes from 'prop-types';
import {toast} from "react-toastify";
import api from "../../../../api";
import TopSurveysRankForm from "./TopSurveysRankForm";

class TopSurveysRankEditButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      updating: false,
      errors: {}
    }

    this.form = React.createRef();
  }

  update(e, data) {
    e.preventDefault();
    this.setState({updating: true});

    api.topSurveysRank.patch({
      data: data.data,
      id: this.props.data.id
    }).then(() => {
      this.props.handleChange();
      toast.success('Zaposano pomyślnie');
      this.setState({
        updating: false,
        modal: false
      })
    }).catch(e => {
      this.setState({
        updating: false,
        errors: e.response.data.form.errors
      });
    });
  }

  toggleModal(){
    this.setState({
      modal: !this.state.modal
    })
  }

  render() {
    const { updating, errors } = this.state;

    const modal = <Modal isOpen={this.state.modal} toggle={() => this.toggleModal()} size="xl">
      <ModalHeader toggle={() => this.toggleModal()} tag="h2">Edycja</ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <TopSurveysRankForm errors={errors} onSubmit={this.update} ref={this.form} data={this.props.data}/>
      </ModalBody>
      <ModalFooter>
        <FormattedMessage id="_.button.save">{
          (message) => <LaddaButton
            className="btn btn-primary btn-ladda"
            loading={updating}
            data-style={ZOOM_OUT}
            onClick={e => this.update(e, this.form.current.state)}
          >
            {message}
          </LaddaButton>
        }</FormattedMessage>
        <FormattedMessage id="_.button.cancel">{
          (message) =>
            <Button color="secondary" onClick={() => this.toggleModal()}>{message}</Button>
        }</FormattedMessage>
      </ModalFooter>
    </Modal>;

    return (
      <React.Fragment>
        <Button color="primary" size="sm" onClick={() => this.toggleModal()}><i className="fas fa-edit" /> <FormattedMessage id="_.button.edit"/></Button>
        {modal}
      </React.Fragment>
    )
  }
}

TopSurveysRankEditButton.propTypes = {
  data: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired
};

export default TopSurveysRankEditButton;